<template>
  <b-modal id="modal_form"
           ref="modal_form"
           :title="modal_titulo"
           :ok-title="modal_botao"
           close-title="Fechar"
           cancel-title="Cancelar"
           size="md"
           no-close-on-esc
           no-close-on-backdrop
           :ok-disabled=form.errors.any()
           v-model="showModal"
           @ok="handleOk">
    <form @submit.stop.prevent="handleOk">
      <b-row class="pb-1">
          <b-col>
                <b-input type="text" class="form-control" v-model="form.chave" :maxlength="44" @keyup.enter="doFilter"></b-input>
          </b-col>
      </b-row>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal=false" variant="secondary">
          Fechar
        </b-btn>
        <b-btn @click="handleOk($event)" variant="secondary">
          Salvar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>

import AvisoErros from '../components/AvisoErros'

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
  },
  data () {
    return {
      dataExport: [],
      modal_titulo: '',
      permission: true,
      paste: false,
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: true,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      errors_array: [],
      docfis: [],
      form: new Form({
            chave: ''
          }
      ),
      css: {
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
    }
  },
  methods: {
    handleOk(e)
    {
      e.preventDefault();
      this.onUpdate(this.form.carga_id);
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit('setVuetableFilterButton', false);
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onEdit(carga_id, obs) {
      this.loading = false;
      this.isDisabled = false;
      this.modal_titulo = "Manifesto";
      this.modal_botao = "Salvar";
      // this.form.chave = "";
      this.errors_array = [];
      this.form.reset();
      this.form.carga_id = carga_id;
      this.form.obs = obs;
      this.$refs.modal_form.show();
    },
    onUpdate(id)
    {
      this.loading = true;
      this.isDisabled = true;
      this.form.post('/api/montagemcarga/recebimentomdfe').then(response =>
      {
        new ReturnApi(response, this)
        this.$parent.onFilterReset();
      })
          .catch(errors =>
          {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
          });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    checkPermissionBip() {
      return this.getPermissionFw('montagemcarga.digitaretiqueta');//
    },
    qtdCaracteres(){
      return this.cd_barra.length;
    }
  },
  computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
}
</script>
